<div fxLayout="row" fxLayoutAlign="space-between center">
	<button *ngIf="showPrint" mat-raised-button color="primary" (click)="print()">
		<mat-icon aria-hidden="false" aria-label="Print Icon">print</mat-icon> Print
	</button>
	<button *ngIf="showDownload" mat-raised-button color="primary" (click)="download()">
		<mat-icon aria-hidden="false" aria-label="Download Icon">file_download</mat-icon>
		Download
	</button>
</div>
